import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let SetupSelectionComponent = {
    selector: "vcSetupSelection",
    templateUrl: "/angular/components/campaign/setup-selection.component.html",
    bindings: {},
    controller: class SetupSelectionComponentController {
        private $window: any;
        private $cookies: any;
        private dialog: DialogUtils;

        constructor($window: any, $cookies: any, DialogUtils: DialogUtils) {
            this.$window = $window;
            this.$cookies = $cookies;
            this.dialog = DialogUtils;
        }

        select(option: string): void {
            this.$window.location = "#/" + option;
            this.dialog.hide();
        }
        hide(): void {
            this.$cookies.put("started", 1);
            this.dialog.hide();
        }
    },
};

angular
    .module("campaign")
    .component(SetupSelectionComponent.selector, SetupSelectionComponent);
